var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c(
              "div",
              { staticClass: "row position-relative" },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c("h1", { staticClass: "h3" }, [
                    _c("span", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.currentVariation.texts.name1) +
                          "\n                            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("hr")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-wrap justify-content-between align-items-center mb-2"
                      },
                      [
                        _vm._t("rating-stars-dropzone"),
                        _vm._v(" "),
                        _c("add-to-wish-list", {
                          attrs: {
                            "variation-id": _vm.currentVariation.variation.id
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.attributes.length ||
                              Object.keys(_vm.units).length,
                            expression:
                              "attributes.length || Object.keys(units).length"
                          }
                        ],
                        staticClass: "mb-3"
                      },
                      [_c("variation-select")],
                      1
                    ),
                    _vm._v(" "),
                    _vm.currentVariation.variation.bundleType === "bundle"
                      ? _c("item-bundle", {
                          attrs: {
                            "bundle-type":
                              _vm.currentVariation.variation.bundleType,
                            "bundle-components":
                              _vm.currentVariation.bundleComponents
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("before-price"),
                    _vm._v(" "),
                    _vm.currentVariation.filter.isSalable &&
                    _vm.variationGroupedProperties.length
                      ? _c("div", [_c("order-property-list")], 1)
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("item-price", {
                            attrs: { "show-cross-price": true }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(0)
                    ]),
                    _vm._v(" "),
                    _vm._t("after-price"),
                    _vm._v(" "),
                    _c("item-availability"),
                    _vm._v(" "),
                    _c("graduated-prices"),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3 d-print-none" }, [
                      _c(
                        "div",
                        { staticClass: "w-100" },
                        [_vm._t("before-add-to-basket")],
                        2
                      ),
                      _vm._v(" "),
                      _vm.currentVariation.item.itemType === "set"
                        ? _c("div", { staticClass: "alert alert-info w-100" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemSetInfo"
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        : _c(
                            "div",
                            { staticClass: "position-relative" },
                            [
                              _c("add-to-basket", {
                                attrs: {
                                  "variation-id":
                                    _vm.currentVariation.variation.id,
                                  "is-salable":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-children":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter
                                      .hasActiveChildren,
                                  "interval-quantity":
                                    _vm.currentVariation.variation
                                      .intervalOrderQuantity || 1,
                                  "minimum-quantity":
                                    _vm.currentVariation.variation
                                      .minimumOrderQuantity,
                                  "maximum-quantity":
                                    !!_vm.currentVariation.variation
                                      .maximumOrderQuantity &&
                                    _vm.currentVariation.variation
                                      .maximumOrderQuantity > 0
                                      ? _vm.currentVariation.variation
                                          .maximumOrderQuantity
                                      : null,
                                  "order-properties": _vm.currentVariation.properties.filter(
                                    function(prop) {
                                      return prop.property.isOderProperty
                                    }
                                  ),
                                  "has-order-properties":
                                    _vm.currentVariation.hasOrderProperties,
                                  "has-required-order-property":
                                    _vm.currentVariation
                                      .hasRequiredOrderProperty,
                                  "use-large-scale": false,
                                  "show-quantity": true,
                                  "item-url": _vm._f("itemURL")(
                                    _vm.currentVariation
                                  ),
                                  "is-variation-selected":
                                    _vm.isVariationSelected &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-price": _vm._f("hasItemDefaultPrice")(
                                    _vm.currentVariation
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("lazy-img", {
                                attrs: {
                                  "image-url":
                                    _vm.$ceres.basePath +
                                    "/images/template/trustedshops.png",
                                  id: "atb-seal",
                                  alt:
                                    "Trusted Shops geprüfter Onlineshop mit Käuferschutz"
                                }
                              })
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-100 d-flex mt-3 flex-wrap justify-content-center after-atb"
                        },
                        [_vm._t("after-add-to-basket")],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.currentVariation.prices.default.price.value > 99
                      ? _c(
                          "div",
                          [_vm._t("additional-content-after-add-to-basket")],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("installment-promo"),
                    _vm._v(" "),
                    _vm._t("additional-content-after-vat"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.currentVariation.prices.default.price.value >
                              80,
                            expression:
                              "currentVariation.prices.default.price.value > 80"
                          }
                        ],
                        staticClass: "text-center mt-3 font-weight-bold"
                      },
                      [
                        _c("span", [
                          _vm._v("- oder telefonisch beraten lassen  -")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _vm._m(1)
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("crossselling-accessory"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-sm-12 col-md-8 mt-5",
                    attrs: { id: "description" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "description" },
                      [
                        _vm._t("description"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-wrap justify-content-between align-items-center"
                          },
                          [
                            _c("b", { staticClass: "articlenumber small" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemNumber"
                                    )
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm.currentVariation.variation.number
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 col-12 text-center mt-5" },
                  [
                    _c("lazy-img", {
                      attrs: {
                        "picture-class": "img-rounded jaeger",
                        "image-url":
                          _vm.$ceres.basePath +
                          "/images/template/gerold-profil.jpg",
                        alt: "Gerold Jäger - Inhaber Motivationsgeschenke.de"
                      }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3)
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._t("crossselling-similar"),
                _vm._v(" "),
                _vm._t("last-seen"),
                _vm._v(" "),
                _vm._t("ratings-dropzone")
              ],
              2
            )
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 d-flex align-items-center" }, [
      _c("ul", { staticClass: "small", attrs: { id: "uvpSingleItem" } }, [
        _c("li", [
          _c("i", {
            staticClass: "fa fa-check",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" 100 Tage Rückgaberecht")
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", {
            staticClass: "fa fa-check",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" Trusted-Shops Käuferschutz")
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", {
            staticClass: "fa fa-check",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" Kauf auf Rechnung")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "tel:0931/8041133" } }, [
      _c("i", { staticClass: "fa fa-phone", attrs: { "aria-hidden": "true" } }),
      _vm._v(" 0931-8041133\n                        anrufen")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("b", [_vm._v("Grüß Gott,")]),
      _vm._v(" ich bin Gerold Jäger."),
      _c("br"),
      _vm._v("Bei Fragen, schreiben Sie mir gerne eine ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-primary" }, [
      _c("i", {
        staticClass: "fa fa-envelope",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "text-primary",
          staticStyle: { "text-decoration": "underline" },
          attrs: {
            target: "_blank",
            href: "https://www.motivationsgeschenke.de/kontakt"
          }
        },
        [_vm._v("Nachricht über unser Kontaktformular")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }